import React from 'react'

const SupplyChain = () => {
    return (
        <div>
            <h1>Supply Chain</h1>
        </div>
    )
}

export default SupplyChain